import { useContext } from 'react';
import AppContext from '@context';
import { getFeaturesAllowedCompany } from '@services/featuresAllowed';
import { FeaturesAllowedItemInterface } from '@context/reducers';

const useFeaturesAllowed = () => {
  const {
    state: { featuresAllowed },
    dispatch,
  } = useContext(AppContext);

  function featureHasLoaded(
    feature: string,
  ): FeaturesAllowedItemInterface | false {
    const featureSearched = featuresAllowed.data.find(
      (featuresAllowedState) => featuresAllowedState.feature === feature,
    );

    return featureSearched || false;
  }

  function isloadingFeatureAllowed(feature: string): boolean {
    const featureSearched = featureHasLoaded(feature);
    if (!featureSearched) {
      return false;
    }
    return featureSearched.isLoading;
  }

  function isFeatureAllowed(feature: string) {
    const featureSearched = featureHasLoaded(feature);
    if (!featureSearched) {
      return false;
    }
    return featureSearched.allowed;
  }

  function requestUpdateFeaturesAllowed(feature: string): Promise<void> {
    dispatch({
      type: 'featuresAllowed_update',
      payload: {
        feature,
        allowed: false,
        isLoading: true,
      },
    });

    return getFeaturesAllowedCompany(feature)
      .then(() => {
        dispatch({
          type: 'featuresAllowed_update',
          payload: {
            feature,
            allowed: true,
            isLoading: false,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: 'featuresAllowed_update',
          payload: {
            feature,
            allowed: false,
            isLoading: false,
          },
        });
      });
  }

  return {
    requestUpdateFeaturesAllowed,
    isloadingFeatureAllowed,
    isFeatureAllowed,
    featureHasLoaded,
  };
};

export default useFeaturesAllowed;
